export default __webpack_public_path__ + "static/nlp-31beaf4799b97f2bab4675dbd8d594ce.png";